/* unplugin-vue-components disabled */
import {DropdownCalendar} from 'components/filters'
import {API_TASKS} from 'consts/api'
import TasksRunner from 'components/tasks-runner'

export default {
  components: {
    DropdownCalendar,
    TasksRunner
  },
  data() {
    return {
      filter_dates: [],
      bin_size: '1D',
      stale_threshold_hours: 72,
      trailing_days: 7,
      compare: false,
      fetch_channels: true,
      bin_size_items: [
        {label: '1 hour', value: '1H'},
        {label: '6 hours', value: '6H'},
        {label: '12 hours', value: '12H'},
        {label: '1 day', value: '1D'},
        {label: '1 week', value: '1W'},
      ],
    }
  },
  computed: {
    can_run(){
      return !!(
        this.filter_dates.length &&
        this.bin_size &&
        this.stale_threshold_hours > 0 &&
        this.trailing_days > 0
      )
    },
    min_date(){
      const min_date = new Date()
      min_date.setDate(min_date.getDate() - 60)
      return min_date
    },
    date(){
      if (!this.filter_dates.length) return
      const start = this.filter_dates && this.filter_dates[0] && $utils.format.date(this.filter_dates[0])
      const end = this.filter_dates && this.filter_dates[1] && `${$utils.format.date(this.filter_dates[1])}`
      return `${start} - ${end}`
    },
  },
  methods: {
    validate() {
      if (!this.filter_dates.length) {
        $utils.toasts.error('Please select date range')
        return false
      }
      if (!this.bin_size) {
        $utils.toasts.error('Please select bin size')
        return false
      }
      if (!(this.stale_threshold_hours > 0)) {
        $utils.toasts.error('Stale threshold hours must be greater than 0')
        return false
      }
      if (!(this.trailing_days > 0)) {
        $utils.toasts.error('Trailing days must be greater than 0')
        return false
      }
      return true
    },
    async runPulseDashboard(tasks) {
      if (!this.validate()) return

      const [min_date, max_date] = $utils.format.normalizeDateRange(this.filter_dates)
      const payload = {
        min_date,
        max_date,
        bin_size: this.bin_size,
        stale_threshold_hours: this.stale_threshold_hours,
        trailing_days: this.trailing_days,
        compare: this.compare,
        fetch_channels: this.fetch_channels,
      }
      const options = {
        force_form_data: true
      }

      const formData = new FormData()
      formData.append('payload', JSON.stringify(payload))

      return await tasks.start(`${API_TASKS}/pulse-dashboard`, formData, options)
    }
  }
}
